import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@codes/ui-kit/components/ui/select';
import { CatalogStereo } from '@lemoncloud/codes-goods-api';
import { getStereoDisplayName } from '@web/app/shared';

interface StereoSelectProps {
    value: CatalogStereo | 'all';
    onChange: (value: CatalogStereo | 'all') => void;
    stereos: CatalogStereo[];
}

export const StereoSelect = ({ value, onChange, stereos }: StereoSelectProps) => {
    const { t } = useTranslation();

    return (
        <Select value={value} onValueChange={t => onChange(t as CatalogStereo | 'all')}>
            <SelectTrigger className="py-[9px] pr-3 pl-4 border-border rounded-full w-fit">
                <SelectValue placeholder={t('common.all')} />
            </SelectTrigger>
            <SelectContent className="border-none shadow-custom">
                <SelectItem value="all" className="text-text">
                    {t('common.all')}
                </SelectItem>
                {stereos.map((stereoType, idx) => (
                    <SelectItem key={idx} value={stereoType} className="text-text">
                        {getStereoDisplayName(stereoType)}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
